import { useQuery } from '@tanstack/react-query';

import { ConnectionPointsData } from '../types/connectionPoints';
import { apiForms } from 'services/apiService';

export function useConnectionPointsData(fromUserId: string, toUserId: string, enabled = true) {
  const isDev = process.env.NODE_ENV === 'development';

  const { data, isLoading, error } = useQuery<ConnectionPointsData, Error>({
    queryKey: ['connectionPoints', fromUserId, toUserId],
    queryFn: async () => {
      const url = `/v1/analysis/report/connection-points?from_user_uuid=${fromUserId}&to_user_uuid=${toUserId}`;
      if (isDev) console.log('[useConnectionPointsData] Fazendo requisição para:', url);

      const response = await apiForms.get(url);
      if (isDev) console.log('[useConnectionPointsData] Resposta recebida:', response.data);

      return response.data;
    },
    enabled:
      enabled && !!fromUserId && fromUserId.trim() !== '' && !!toUserId && toUserId.trim() !== '',
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

  return {
    data: data || null,
    loading: isLoading,
    error: error?.message || null,
  };
}
